import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import { PublicPricingCatalog } from '../types/subscription';

let cachedCatalog: PublicPricingCatalog | null = null;

export async function getPublicPricingCatalog(
  forceRefresh = false
): Promise<PublicPricingCatalog> {
  if (cachedCatalog && !forceRefresh) return cachedCatalog;

  const callable = httpsCallable<void, PublicPricingCatalog>(
    functions,
    'getPublicPricingCatalog'
  );
  const result = await callable();
  cachedCatalog = result.data;
  return result.data;
}
